import React, { useContext } from "react";
import { useDispatch } from "react-redux";
import SelectMedia from "/@src/components/newComponents/MediaEditor/SelectMedia";
import { openModal } from "/@src/redux/modal/actions";

export const MediaContext = React.createContext({});

export const useMediaContext = () => useContext(MediaContext);

const MediaProvider = ({ children }) => {
  const dispatch = useDispatch();
  const selectMedia = (onSelect, type, allowedType) => {
    
    dispatch(
      openModal({
        id: "select-media",
        title: "Select Media",
        size: "xl",
        children: (
          <SelectMedia
            confirmSelected={onSelect}
            type={type}
            allowedType={allowedType}
          />
        ),
      })
    );
  };


  return (
    <MediaContext.Provider value={{mediaSelector : selectMedia}}>
      {children}
    </MediaContext.Provider>
  );
};

export default MediaProvider;
